// export const baseURL = 'https://nef_backend.test/api/v2';
export const baseURL = 'https://api7.eflow.app/api/v2';
//export const baseURL = 'http://127.0.0.1:8000/api/v2';